import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type UserData = {
  email: string;
  email_verified: boolean;
  sub: string;
  username: string;
};

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userData = new BehaviorSubject<UserData | null>(null);

  setUserData(data: UserData): void {
    this.userData.next(data);
  }

  getUserData(): Observable<UserData | null> {
    return this.userData.asObservable();
  }

  getUserName(): Observable<string | null> {
    return this.userData.asObservable().pipe(map(data => data?.username || null));
  }

  clearUserData(): void {
    this.userData.next(null);
  }
}
